'use client';

import React from 'react';
import dynamic from 'next/dynamic';
import { useCaPreview } from '../../lib/caPreview';

// The real button (and its CSS) loads only when the flag is on.
const AddToCartButton = dynamic(() => import('./AddToCartButton'), { ssr: false });

type Props = React.ComponentProps<typeof AddToCartButton> & { className?: string };

/**
 * Add-to-cart for planner gear recommendations, behind ca_preview.
 * Renders nothing at all while the flag is off.
 */
export default function PreviewAddToCart({ className, ...props }: Props) {
  const on = useCaPreview();
  if (!on) return null;
  return (
    <div className={className}>
      <AddToCartButton {...props} />
    </div>
  );
}

/** Same flag, for callers that restyle around the button. */
export { useCaPreview };
